import de from '@translations/de/brandFormPopups.json';
import en from '@translations/en/brandFormPopups.json';
import pl from '@translations/pl/brandFormPopups.json';
import sl from '@translations/sl/brandFormPopups.json';
import uk from '@translations/uk/brandFormPopups.json';
import bg from '@translations/bg/brandFormPopups.json';
import cz from '@translations/cz/brandFormPopups.json';
import fr from '@translations/fr/brandFormPopups.json';
import gr from '@translations/gr/brandFormPopups.json';
import it from '@translations/it/brandFormPopups.json';
import pr from '@translations/pr/brandFormPopups.json';
import ru from '@translations/ru/brandFormPopups.json';
import sk from '@translations/sk/brandFormPopups.json';
import sp from '@translations/sp/brandFormPopups.json';
import tr from '@translations/tr/brandFormPopups.json';
import hu from '@translations/hu/brandFormPopups.json';
import { ITranslations } from '@/types/common';
import { BrandFormPopupsTransFields } from './types';

export const brandFormPopupsTranslations: ITranslations<BrandFormPopupsTransFields> = {
  name: 'brandFormPopups',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
